import { ActionButton, IconButton, PrimaryButton } from '@fluentui/react';
import { Icon } from '@fluentui/react/lib/Icon';
import { BotAvatar } from '../BotAvatar';
import { UserAvatar } from '../UserAvatar';
import { ResourceDetails } from '../ResourceDetails';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import styles from './ChatMessage.module.sass';
import { useCustomerTheme } from '../Theme';
import { useState } from 'react';

interface ChatMessageProps {
    message: any;
    index: number;
    isLastMessage: boolean;
    onSubmitInput: (input: string) => void;
    onFeedback: (index: number, isPositive: boolean) => void;
    resourceSelected?: (resource: any) => void;
}

export const ChatMessage = ({ message, index, isLastMessage, onSubmitInput, onFeedback, resourceSelected }: ChatMessageProps) => {
    const { theme, setTheme } = useCustomerTheme();
    const [sourcesListOpen, setSourcesListOpen] = useState(false);
    const sources = message.sources || [
        'Quelle 1: Beispielhafte Quelle',
        'Quelle 2: Weitere Quelle',
    ];

    switch (message.type) {
        case 'botMessage':
            return (message.content && message.content.length > 0) ||
                (message.resources && message.resources.length > 0)
                ?
                <div>
                    <div className={styles.messageContainer}>
                        <BotAvatar />
                        <div className={styles.chatBotMessage}>
                            <div className={styles.chatBotMessageArrow}></div>
                            <div className='markdown'>
                                <Markdown rehypePlugins={[rehypeRaw] as any} remarkPlugins={[remarkGfm]}>{message.content}</Markdown>
                            </div>
                        </div>
                        <div className='displayFlex justifyContentStart'>
                        </div>
                    </div>
                    {message.resources && <ResourceDetails resources={message.resources} resourceSelected={resourceSelected} />}
                    {message.resources && message.resources.filter((resource: any) => resource.type === 'source').length > 0 && (
                        <div className='marginTopM marginBottomM'>
                            <div>
                                <ActionButton className="marginRightM" iconProps={{ iconName: sourcesListOpen ? 'ChevronUp' : 'ChevronDown', style: { fontSize: '14px' } }} onClick={() => setSourcesListOpen(!sourcesListOpen)}>
                                    <div className='colorPrimary'>Quellen</div>
                                </ActionButton>
                            </div>
                            <div>
                            </div>
                            {sourcesListOpen && (
                                <div className={styles.sourcesList}>
                                    {message.resources && message.resources.filter((resource: any) => resource.type === 'source').length > 0
                                        ?
                                        <ul>
                                            {message.resources.filter((resource: any) => resource.type === 'source').map((source: any, idx: number) => (
                                                <li key={idx}>
                                                    {source.document
                                                        ?
                                                        <div className='displayFlex alignItemsStart gapS'>
                                                            <Icon iconName="Document" style={{ marginRight: '8px', fontSize: '14px', color: 'var(--primary-color)' }} />
                                                            <a href={source.url} target="_blank" rel="noopener noreferrer">{source.document}</a>
                                                            <div className='colorPrimary'>{source.provider}</div>
                                                        </div>
                                                        :
                                                        <div className='displayFlex alignItemsStart gapS'>
                                                            <Icon iconName="Document" style={{ marginRight: '8px', fontSize: '14px', color: 'var(--primary-color)' }} />
                                                            <a href={source.url} target="_blank" rel="noopener noreferrer">{source.tool}</a>
                                                            <div className='colorPrimary'>{source.provider}</div>
                                                        </div>
                                                    }
                                                </li>
                                            ))}
                                        </ul>
                                        :
                                        <ul>
                                            <li>
                                                <div className='displayFlex alignItemsStart gapS'>
                                                    <Icon iconName="Document" style={{ marginRight: '8px', fontSize: '14px', color: 'var(--primary-color)' }} />
                                                    <a href="https://www.the-real-insight.com" target="_blank" rel="noopener noreferrer">Real Estate Data Platform</a>
                                                    <div className='colorPrimary'>The Real Insight GmbH, Seckbachstraße 10, 60313 Frankfurt am Main</div>
                                                </div>
                                            </li>
                                        </ul>
                                    }
                                </div>
                            )}
                        </div>

                    )}
                    {isLastMessage && message.confirmation && (
                        <div className='displayFlex justifyContentEnd'>
                            <PrimaryButton onClick={() => onSubmitInput('yes')} text="Yes" />
                        </div>
                    )}
                    <div className={isLastMessage ? 'lastFeedbackButtons' : 'feedbackButtons'}>
                        <ActionButton
                            className='feedbackButton'
                            iconProps={{ iconName: 'Like' }}
                            onClick={() => onFeedback(index, true)}
                            ariaLabel="Thumbs up"
                        />
                        <ActionButton
                            className='feedbackButton'
                            iconProps={{ iconName: 'Dislike' }}
                            onClick={() => onFeedback(index, false)}
                            ariaLabel="Thumbs down"
                        />
                    </div>
                </div >
                : null;

        case 'botSuggestion':
            return (
                <div>
                    <div className={styles.messageContainer}>
                        <BotAvatar />
                        <div className={styles.chatBotSuggestion}>
                            {message.content}
                        </div>
                    </div>
                    {message.resources && <ResourceDetails resources={message.resources} />}
                    {isLastMessage && (
                        <div className='displayFlex justifyContentEnd'>
                            <PrimaryButton onClick={() => onSubmitInput('yes')} text="Yes" />
                        </div>
                    )}
                </div>
            );

        case 'userMessage':
            return (
                <div>
                    <div className={styles.userMessageContainer}>
                        <div className={styles.userMessage}>
                            {message.content}
                        </div>
                        <UserAvatar />
                    </div>
                </div>
            );

        default:
            return null;
    }
}; 